<template lang="pug">
  .video-box
    video(:src="videoFullSrc" :autoplay="autoplay" :muted="muted" :loop="loop" :playsinline="playsinline" :preload="preload" role="presentation")

</template>

<script lang="js">
  export default {
    name: 'VideoBox',

    props: {
      videoSrc: {
        type: String,
        required: false
      },
      autoplay: {
        type: Boolean,
        default: true
      },
      muted: {
        type: Boolean,
        default: true
      },
      loop: {
        type: Boolean,
        default: true
      },
      playsinline: {
        type: Boolean,
        default: true
      },
      preload: {
        type: String,
        default: 'auto'
      }
    },

    computed: {
      videoFullSrc() {
        if (!this.videoSrc) {
          return '';
        }

        const imgixPrefix = 'https://mr-cdn.imgix.net/';
        const imgixPrefixStaging = 'https://mr-cdn-staging.imgix.net';
        const cloudfrontPrefix = 'https://media.madison-reed.com/d3ewrnwdcmri66.cloudfront.net/';
        const cloudfrontPrefixStaging = 'https://media-staging.madison-reed.com/ddxs94deh28np.cloudfront.net/';

        if (this.videoSrc.startsWith(imgixPrefix)) {
          return cloudfrontPrefix + this.videoSrc.substring(imgixPrefix.length);
        }

        if (this.videoSrc.startsWith(imgixPrefixStaging)) {
          return cloudfrontPrefixStaging + this.videoSrc.substring(imgixPrefixStaging.length);
        }

        return "https://media.madison-reed.com/" + this.videoSrc;
      }
    },

    methods: {
      remapUrl(url) {
        if (!url) {
          return url;
        }

        const mediaDomain = 'https://media.madison-reed.com/';

        if (url.startsWith(mediaDomain)) {
          return url;
        }

        const imgixPrefix = 'https://mr-cdn.imgix.net/';
        const imgixPrefixStaging = 'https://mr-cdn-staging.imgix.net';
        const cloudfrontPrefix = `${mediaDomain}d3ewrnwdcmri66.cloudfront.net/`;
        const cloudfrontPrefixStaging = `${mediaDomain}ddxs94deh28np.cloudfront.net/`;

        if (url.startsWith(imgixPrefix)) {
          return cloudfrontPrefix + url.substring(imgixPrefix.length);
        }

        if (url.startsWith(imgixPrefixStaging)) {
          return cloudfrontPrefixStaging + url.substring(imgixPrefixStaging.length);
        }

        return mediaDomain + url.replace('https://', '');
      },
    }
  };


</script>


<style scoped lang="stylus">

</style>